/**
 * Feedback report DTOs — the in-app screenshot report (Report Sheet) and its
 * CMS triage view. Option IDs are fixed; never rename or reuse one, so old
 * reports keep their meaning.
 */
/**
 * Fixed ID → English label mapping, so the CMS shows readable labels. The app
 * hard-codes its own labels (en / zh-HK / zh-CN); this list only mirrors the IDs.
 */
export const FEEDBACK_REPORT_OPTION_LABELS = {
    bug: "Something isn't working",
    ai: 'AI got it wrong',
    ux: 'Hard to use',
    idea: 'Suggestion',
    other: 'Other',
    bug_crash: 'App crashed',
    bug_no_response: 'Tapped, nothing happened',
    bug_slow: "Slow or won't load",
    bug_display: 'Display error',
    bug_data: 'Data missing or not saved',
    bug_payment: 'Payment or subscription',
    ux_find: "Can't find a feature",
    ux_meaning: "Don't understand the wording or numbers",
    ux_next: 'Not sure what to do next',
    food: 'Food',
    workout: 'Workout',
    coach: 'AI Coach',
    ai_food_wrong_food: 'Wrong food identified',
    ai_food_portion: 'Portion size off',
    ai_food_nutrition: 'Calories or nutrients off',
    ai_food_score: "Score doesn't make sense",
    ai_workout_not_for_me: 'Exercise not right for me',
    ai_workout_equipment: 'Wrong equipment',
    ai_workout_sets: "Sets or reps don't make sense",
    ai_coach_advice: "Advice doesn't make sense",
    ai_coach_mismatch: "Doesn't match my data",
    ai_coach_tone: 'Tone feels off',
    ai_unsafe: 'Upsetting or potentially unsafe',
    ai_other: 'Other',
    sev_blocks: 'Blocks me',
    sev_affects: 'Affects me',
    sev_minor: 'Minor',
    auto_capture: 'Auto capture',
    user_selected: 'Selected by tester',
};
